import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "right-content" }
const _hoisted_4 = {
  key: 0,
  class: "right-content-item"
}
const _hoisted_5 = {
  key: 1,
  class: "right-content-item"
}
const _hoisted_6 = {
  key: 2,
  class: "right-content-item"
}
const _hoisted_7 = {
  key: 3,
  class: "right-content-item"
}

import { ref, onMounted, onUnmounted } from 'vue';
import { emitter } from '@/utils/events';
import { MyLeftTabList, BlankTemplateStepsData, PdftoVideoStepsData } from './data';
import TemplateList from './components/TemplateList.vue';
import QuickCreateVideoFrom from './components/QuickCreateVideoFrom.vue';
import BlankTemplate from './components/BlankTemplate.vue';
import { useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const dialogVisible = ref(false);

const leftTabList = ref(MyLeftTabList);
const selectedData = ref(MyLeftTabList.length > 0 ? MyLeftTabList[0] : null);
const qcSelectTemplateData = ref<Record<string, any>>({});
const showQuickCreateVideoFrom = ref(false);
const blankTemplateStepsData = ref(BlankTemplateStepsData);

const router = useRouter();

const handleTabClick = (item: any) => {
  // 如果不是点击快速创建，则关闭快速创建
  if (item.id !== 1) {
    showQuickCreateVideoFrom.value = false;
  }
  selectedData.value = item;
};

// 返回上一步
const handleBack = () => {
  showQuickCreateVideoFrom.value = false;
};

// 快速创建选择模板
const quickCreateSelectTemplate = (template: any) => {
  qcSelectTemplateData.value = template || {};
  showQuickCreateVideoFrom.value = true;
};

const selectTemplateCreateVideo = (template: any) => {
  window.location.href = `${window.origin}/design/#/${template?.id ? `?tempid=${template.id}` : ''}`;
};

// 监听事件
onMounted(() => {
  emitter.on('openCreateVideoDialog', () => {
    dialogVisible.value = true;
  });
  emitter.on('closeCreateVideoDialog', () => {
    dialogVisible.value = false;
  });
});

// 组件卸载时移除事件监听
onUnmounted(() => {
  emitter.off('openCreateVideoDialog');
  emitter.off('closeCreateVideoDialog');
});

const handleClose = () => {
  showQuickCreateVideoFrom.value = false;
  dialogVisible.value = false;
};

const handleUseBlankTemplate = () => {
  // 处理空白模板的使用逻辑
  console.log('使用空白模板创建视频');
  // 这里可以添加跳转到创建页面或其他逻辑
  dialogVisible.value = false; // 关闭对话框
  window.location.href = `${window.origin}/design/#/`;
};

const handleUsePdftoVideo = () => {
  // 处理ppt转视频的使用逻辑
  console.log('使用ppt转视频');
  // 这里可以添加跳转到创建页面或其他逻辑
  dialogVisible.value = false; // 关闭对话框
  router.push('/pdf-to-video');
};

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    top: "2vh",
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
    title: "创建视频",
    width: "56%",
    "destroy-on-close": "",
    "close-on-click-modal": false,
    onClose: handleClose,
    class: "create-video-dialog custom-el-dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_row, {
          gutter: 10,
          class: "content-row"
        }, {
          default: _withCtx(() => [
            true
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 0,
                  span: 5,
                  class: "left"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leftTabList.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "left-list",
                        key: item.id
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["left-item", { active: selectedData.value?.id === item.id }]),
                          onClick: ($event: any) => (handleTabClick(item))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(item.icon)
                          }, null, 2),
                          _createElementVNode("span", null, _toDisplayString(item.label), 1)
                        ], 10, _hoisted_2)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_col, {
              span: 19,
              class: "right"
            }, {
              default: _withCtx(() => [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "right-header" }, null, -1)),
                _createElementVNode("div", _hoisted_3, [
                  (selectedData.value?.id === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (!showQuickCreateVideoFrom.value)
                          ? (_openBlock(), _createBlock(TemplateList, {
                              key: 0,
                              onSelectTemplate: quickCreateSelectTemplate
                            }))
                          : (_openBlock(), _createBlock(QuickCreateVideoFrom, {
                              key: 1,
                              template: qcSelectTemplateData.value,
                              onBack: handleBack,
                              onClose: handleClose
                            }, null, 8, ["template"]))
                      ]))
                    : _createCommentVNode("", true),
                  (selectedData.value?.id === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(BlankTemplate, {
                          stepsRows: blankTemplateStepsData.value,
                          title: '空白模板创建视频',
                          onUseBlankTemplate: handleUseBlankTemplate
                        }, null, 8, ["stepsRows"])
                      ]))
                    : _createCommentVNode("", true),
                  (selectedData.value?.id === 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (!showQuickCreateVideoFrom.value)
                          ? (_openBlock(), _createBlock(TemplateList, {
                              key: 0,
                              onSelectTemplate: selectTemplateCreateVideo,
                              title: '选择模板创建视频'
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (selectedData.value?.id === 4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(BlankTemplate, {
                          stepsRows: _unref(PdftoVideoStepsData),
                          title: 'ppt转视频',
                          onUseBlankTemplate: handleUsePdftoVideo
                        }, null, 8, ["stepsRows"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})